<template>
    <div class="control-list" :class="{horizontal}">
        <div v-for="(field, fieldIndex) in schema" :key="fieldIndex" :style="sectionStyle(field)">
            <DynamicControl :value="value[field.name]" :context="context" :record="value" :schema="field" 
                @change="emitChanges(...arguments, field.name)" :key="fieldIndex"
            />
        </div>
    </div>
</template>

<script>



export default {


    data() {
        return {
            
        }
    },

    components: {
        
    },
    
    props: {
        schema: Array,
        value: Object, 
        horizontal: Boolean,
        context: Object,
    },

    computed: {
        
    },

    methods: {
        sectionStyle(field) {
            const style = {}
            if(this.horizontal) {
                style.minWidth = '130px';
                if(field.width) {
                    style['flex-basis'] = field.width
                    style['flex-grow'] = 1
                } else {
                    style['flex-grow'] = 5
                    style['flex-shrink'] = 5
                }
            }
            return style
        },
        emitChanges(newVal, fieldName) {
            const obj = {...this.value}
            this.$set(obj, fieldName, newVal)
            this.$emit('change', obj)
        }
    },
    watch:{

    },
    created() {

    },
}
</script>

<style scoped>
    .control-list.horizontal {
        display:flex;
        flex-wrap:wrap;
        gap: 20px;
    }
</style>




// WEBPACK FOOTER //
// ControlList.vue?67efb04a